module.exports = __webpack_public_path__ + "static/media/veryvell_2_filter.60fbfa72.png";